export default {
  props: {
    decorator: {
      required: false
    }
  },
  computed: {
    decoratorType () {
      if (this.decorator !== 'none') {
        return this.decorator || 'default'
      }
    }
  }
}
